module.exports = __webpack_public_path__ + "static/img/2.1fa2751.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/2.png
// module id = NnEV
// module chunks = 0